import {createSvgIcon} from '../create-svg-icon';

export const DesktopAccessDisabledIcon = createSvgIcon(
  <path d="M1.41 1.69 0 3.1l1 .99V16c0 1.1.89 2 1.99 2H10v2H8v2h8v-2h-2v-2h.9l6 6 1.41-1.41-20.9-20.9zM2.99 16V6.09L12.9 16H2.99zM4.55 2l2 2H21v12h-2.45l2 2h.44c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2H4.55z" />
, 'DesktopAccessDisabledOutlined');
